module.exports = __webpack_public_path__ + "static/media/DE_Ordkjede.89bac307.mp4";